"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _util = _interopRequireDefault(require("util"));

var _lodash = require("lodash");

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function has(object, key) {
  if (!(object && key)) throw new Error('has requires object and key');
  if (_typeof(object) !== 'object') throw new Error('has(object) must be an object');
  if (typeof key !== 'string') throw new Error('has(_,key) must be a string');
  if (object instanceof Map) return object.has(key);
  var keys = Array.from(Object.keys(object));
  return keys.includes(key);
}

var Term = /*#__PURE__*/function () {
  function Term(init) {
    if (init === void 0) {
      init = {};
    }

    this.id = Term.nextId;
    Term.nextId += 1;
    this.copy(init);
  }

  var _proto = Term.prototype;

  _proto.clone = function clone(withParent) {
    var clone = new Term(this);

    if (withParent) {
      clone.parent = this.parent;
    }

    return clone;
  };

  _proto.copy = function copy(_ref) {
    var props = _ref.props,
        value = _ref.value;

    if (props) {
      this.props = props;
    } else {
      this.props = new Map();
    }

    this.value = value;
  };

  _proto.containsTime = function containsTime(t) {
    if (!this.isValidTime) return false;
    return t >= this.start && t < this.end;
  };

  _proto.intersects = function intersects(start, end) {
    if (Array.isArray(start)) return this.intersects.apply(this, start);

    if (!((0, _lodash.isNumber)(start) && (0, _lodash.isNumber)(end))) {
      return false;
    }

    return start < this.end && end > this.start;
  };

  _proto.intersectsRanges = function intersectsRanges(ranges) {
    var _this = this;

    if (!ranges && Array.isArray(ranges)) {
      return false;
    }

    return ranges.reduce(function (isFound, range) {
      if (isFound) return isFound;
      if (!Array.isArray(range)) return false;
      return _this.intersects.apply(_this, range);
    }, false);
  };

  _proto.filterRanges = function filterRanges(ranges) {
    var _this2 = this;

    if (!ranges && Array.isArray(ranges)) {
      return [];
    }

    return ranges.filter(function (range) {
      return _this2.intersects(range);
    });
  };

  _proto.get = function get(name) {
    return this.has(name) ? this._props.get(name) : null;
  }
  /**
   * @TODO:  investgate/kill; looks sketchy ....
   *
   * @param name
   * @param topmost
   * @param found
   * @returns {Array|*}
   */
  ;

  _proto.getDeep = function getDeep(name, topmost, found) {
    if (topmost === void 0) {
      topmost = false;
    }

    if (found === void 0) {
      found = [];
    }

    if (this.has(name)) {
      found.push(this.get(name));

      if (!topmost && this.parent) {
        this.parent.getDeep(name, topmost, found);
      }
    } else if (this.parent) {
      return this.parent.getDeep(name, topmost, found);
    }

    return found;
  };

  _proto.set = function set(name, value) {
    this.props.set(name, value);
  };

  _proto.getAll = function getAll(name, pSet) {
    var set = pSet || new Set();
    if (this.has(name)) set.add(this.get(name));

    if (this.type === _constants.TYPE_ARRAY) {
      this.value.forEach(function (term) {
        if (term instanceof Term) term.getAll(name, set);
      });
    }

    if (this.type === _constants.TYPE_TERM) {
      this.value.getAll(name, set);
    }

    return set;
  };

  _proto.has = function has(name) {
    return this._props.has(name);
  };

  _proto.freezeRange = function freezeRange() {
    if ('_start' in this) return;
    this._start = this.start;
    this._end = this.end;
  };

  _proto.freezeWords = function freezeWords() {
    this._words = this.getWords();
  };

  _proto.getWords = function getWords(pList) {
    if (pList === void 0) {
      pList = [];
    }

    var list = pList;
    if (this._words) return pList.concat(this._words);

    if (this.get('type') === 'word') {
      list.push(this);
    }

    switch (this.type) {
      case _constants.TYPE_ARRAY:
        this.value.forEach(function (term) {
          list = term.getWords(list);
        });
        break;

      case _constants.TYPE_TERM:
        list = this.value.getWords(list);
        break;

      default: // do nothing

    }

    return list;
  };

  _proto.getClasses = function getClasses(pContext) {
    var context = pContext || this.get('type') || 'word';
    var classes = [];
    if (!(this && this instanceof Term)) return classes;
    this.props.forEach(function (value, key) {
      if (key && value && (0, _lodash.isString)(key) && /^(range:|search)/.test(key)) {
        var className = key.trim().replace(':', '-').replace(/[\W]+/g, '-');
        classes.push(className);
        classes.push('range-true');
      }
    });

    if (this.has('p') && (0, _lodash.isNumber)(this.get('p'))) {
      classes.push("index-" + this.get('p'));
    }

    if (context !== 'word') {
      var words = this.getWords();

      if (words.length) {
        var firstWord = (0, _lodash.first)(words);
        var lastWord = (0, _lodash.last)(words);
        if (firstWord.has('p')) classes.push("p-start-" + firstWord.get('p'));
        if (lastWord.has('p')) classes.push("p-end-" + lastWord.get('p'));
      }
    }

    classes = classes.map(function (c) {
      return context + "-" + c;
    }).join(' ');
    return classes;
  };

  _createClass(Term, [{
    key: "value",
    get: function get() {
      if (!has(this, '_value')) return null;
      return this._value;
    },
    set: function set(value) {
      var _this3 = this;

      if (this === value) throw new Error('circular value');

      if (Array.isArray(value)) {
        if (value.includes(this)) {
          throw new Error('circular values');
        }

        value.forEach(function (subItem) {
          if (subItem === _this3) throw new Error('circluar values');

          if (subItem && Term.typeOf(subItem) === _constants.TYPE_TERM) {
            // eslint-disable-next-line no-param-reassign
            subItem.parent = _this3;
          }
        });
      } else if (value instanceof Term) {
        // eslint-disable-next-line no-param-reassign
        value.parent = this;
      }

      this._value = value;
    }
  }, {
    key: "isValidTime",
    get: function get() {
      var start = this.start,
          end = this.end;
      return (0, _lodash.isNumber)(start) && (0, _lodash.isNumber)(end) && start <= end;
    }
  }, {
    key: "parent",
    get: function get() {
      return this._parent;
    },
    set: function set(p) {
      if (p === this) throw new Error('circular structure');
      this._parent = p;
    }
    /**
     * returns the type of value the term contains
     */

  }, {
    key: "type",
    get: function get() {
      return Term.typeOf(this._value);
    }
  }, {
    key: "isMeta",
    get: function get() {
      return !!this.meta;
    }
  }, {
    key: "meta",
    get: function get() {
      return this.has('m') ? this._props.get('m') : null;
    }
  }, {
    key: "word",
    get: function get() {
      if (this.value && this.type === _constants.TYPE_STRING) return this.value;
      return this.has('w') ? this.get('w') : null;
    },
    set: function set(value) {
      this.set('w', value);
      this.value = value;
    }
  }, {
    key: "p",
    get: function get() {
      return this.has('p') ? this.get('p') : null;
    }
  }, {
    key: "start",
    get: function get() {
      if ('_start' in this) return this._start;
      var start = null;
      this.getAll('s').forEach(function (s) {
        if (start === null || (0, _lodash.isNumber)(s) && start > s) start = s;
      });
      return start;
    }
  }, {
    key: "end",
    get: function get() {
      if ('_end' in this) return this._end;
      var end = null;
      this.getAll('e').forEach(function (s) {
        if (end === null || (0, _lodash.isNumber)(s) && end < s) end = s;
      });
      return end;
    }
  }, {
    key: "length",
    get: function get() {
      return this.values.length;
    }
    /**
     * note- values ALWAYS returns value as an array.
     * @returns {*}
     */

  }, {
    key: "values",
    get: function get() {
      if (!('_value' in this)) {
        return [];
      }

      if (Array.isArray(this._value)) {
        return this._value.slice(0);
      }

      return [this._value];
    },
    set: function set(value) {
      if (value === this) {
        throw new Error('cannot include self as own value');
      }

      if (Array.isArray(value)) {
        if (value.includes(this)) {
          throw new Error('cannot include self in own value');
        }
      }

      this.value = value;
    }
  }, {
    key: "props",
    get: function get() {
      if (!this._props) this._props = new Map();
      return this._props;
    },
    set: function set(value) {
      if (!value) return;

      if (value instanceof Map) {
        this._props = new Map(value.entries());
      } else if (Array.isArray(value)) {
        this._props = new Map(value);
      } else if (_typeof(value) === 'object') {
        this._props = new Map(Object.entries(value));
      } else {
        this._props = new Map();
      }
    }
  }]);

  return Term;
}();

exports["default"] = Term;
Term.nextId = 1;

function shortArray(a) {
  if (!Array.isArray(a)) throw new Error("shortArray passed " + a);
  if (a.length < 5) return a;
  return [].concat(a.slice(0, 2), ['...', (0, _lodash.last)(a)]);
}

Term.propsSummary = function (map) {
  if (!(map instanceof Map)) {
    return '-- non map prop -- ';
  }

  return Array.from(map.entries()).map(function (_ref2) {
    var key = _ref2[0],
        value = _ref2[1];
    return key + " : " + Term.summaryOf(value);
  }).join(',\n');
};

Term.summaryOf = function summaryOf(series) {
  if (Array.isArray(series)) {
    return "[" + shortArray(series).map(function (item) {
      return item instanceof Term ? Term.summaryOf(item) : _util["default"].inspect(item);
    }) + "]";
  }

  if (series instanceof Term) {
    try {
      return "\n      props: " + Term.propsSummary(series.props) + ",\n      value: " + Term.summaryOf(series.value) + "\n      ";
    } catch (error) {
      console.log('error in summaryOf for ', series, error);
      return "err: " + error.message;
    }
  }

  return _util["default"].inspect(series);
};

Term.typeOf = function (item) {
  if (item === null) return _constants.TYPE_NULL;
  if (typeof item === 'string') return _constants.TYPE_STRING;
  if (Array.isArray(item)) return _constants.TYPE_ARRAY;
  if (item instanceof Term) return _constants.TYPE_TERM;

  if (_typeof(item) === 'object') {
    return _constants.TYPE_OBJECT;
  }

  return _constants.TYPE_VALUE;
};